import { useCallback, useRef } from "react";
import { useRouter } from "next/router";
import { getModalHref } from "./modalNavigation.js";
export default function useModalNavigation(name) {
  const router = useRouter();
  const openedHref = useRef(null);
  const opening = useRef(false);
  const isOpen = router.query.modal === name;
  const open = useCallback(async () => {
    if (!router.isReady || isOpen || opening.current) return;
    opening.current = true;
    try {
      const href = getModalHref(router.asPath, name);
      const navigated = await router.push(href, undefined, {
        shallow: true,
        scroll: false
      });
      if (navigated) openedHref.current = href;
    } finally {
      opening.current = false;
    }
  }, [router, name, isOpen]);
  const close = useCallback(() => {
    if (!isOpen) return;
    // An in-app opening owns a history entry, so Close behaves like Back and
    // Forward can reopen it. A direct link/refresh has no known entry to pop.
    if (openedHref.current === router.asPath) router.back();else void router.replace(getModalHref(router.asPath), undefined, {
      shallow: true,
      scroll: false
    });
  }, [router, isOpen]);
  return {
    isOpen,
    open,
    close
  };
}